import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import api from '../../../components/api';
/* eslint-disable */
function useWarehouse() {
  const [searchValue, setSearchValue] = React.useState<string>('');
  const [currentWarehouse, setCurrentWarehouse] = React.useState<{ value: number, label: string } | null>(null);

  const { data: warehouseRes, isLoading: warehouseLoad } = useQuery(
    ['getAll', 'warehouse'],
    () => api.warehouse.getAll(),
  );

  const warehouseList = React.useMemo(() => {
    const resData = warehouseRes?.data?.data;
    if (resData) {
      return resData.map((warehouse) => ({
        value: warehouse.id,
        label: warehouse.name,
      }));
    }
    return [];
  }, [warehouseRes]);

  React.useEffect(() => {
    if (warehouseList && warehouseList.length) setCurrentWarehouse(warehouseList[0]);
  }, [warehouseList]);

  const { data: aisleRes, isLoading: aisleLoad, isFetching, refetch: aisleRefetch } = useQuery(
    ['getAislesByWarehouseId', 'warehouse', currentWarehouse?.value],
    () => api.warehouse.getAislesByWarehouseId(currentWarehouse!.value),
    {
      enabled: !!currentWarehouse && !!currentWarehouse?.value,
    },
  );

  const { data: searchAisle, isLoading: searchAisleLoad, isFetching: searchAisleFetching, refetch: searchAisleRefetch } = useQuery(
    ['find-item', 'warehouse', currentWarehouse?.value],
    () => api.warehouse.findItemsBySearch(currentWarehouse!.value, searchValue ?? ''),
    {
      enabled: !!searchValue,
    },
  );

  useEffect(() => {
    if (searchValue) {
      searchAisleRefetch();
    }
  }, [searchValue]);

  const aisleList = React.useMemo(() => {
    const searchData: any = [];
    let searchList: any = [];
    let resData: any = aisleRes?.data?.data;
    if (searchValue) {
      searchList = searchAisle?.data?.data?.map((list: any) => {
        searchData.push(list?.aisle);
        return list;
      });
      resData = { aisles: searchData };
    }
    console.log('resData', resData);
    const arr: { name: string, items: { level: string, count: number, id: number }[] }[] = [];
    if (resData) {
      for (let i = 0; i < resData.aisles.length; i += 1) {
        const items = {
          level: resData.aisles[i].level,
          id: resData.aisles[i].id,
          count: resData.aisles[i].productCount,
        };
        if (![...arr.map((x) => x.name)].includes(resData.aisles[i].name)) {
          arr.push({
            name: resData.aisles[i].name,
            items: [items],
          });
        } else {
          const index = arr.findIndex((x) => x.name === resData.aisles[i].name);
          arr[index].items.push(items);
        }
      }
    }
    console.log('resData arr', arr);
    return arr;
  }, [aisleRes, searchValue]);

  const navigation = useNavigate();
  const navigateToAdd = () => navigation('/warehouse/add');
  const navigateToDetail = () => {
    if (currentWarehouse) {
      navigation(`/warehouse/add/${currentWarehouse.value}`);
    }
  };

  return {
    search: {
      current: searchValue,
      setCurrent: setSearchValue,
    },
    warehouse: {
      list: warehouseList,
      load: warehouseLoad,
    },
    selectedWarehouse: {
      current: currentWarehouse,
      setCurrent: setCurrentWarehouse,
    },
    aisle: {
      list: aisleList,
      load: aisleLoad || searchAisleLoad || isFetching || searchAisleFetching,
      refetch: aisleRefetch,
    },
    navigation: {
      add: navigateToAdd,
      detail: navigateToDetail,
    },
  };
}

export default useWarehouse;
